export default "__VITE_ASSET__y5rw4Evj__"